import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getIcon } from '../../util/icons';

import { withRouter, NavLink } from 'react-router-dom';

import { MessageModal } from '../modals';

import { isProduction } from '../../util';

class ManagerSidebarNav extends Component{

  state = {
    employeeId: null,
    modalMessage: null,
    hoveringNonImperativesPage: false,
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    let employeeId = params.employeeId;

    //if no employeeId...user accessing sprint
    //TODO figure out a better way of managing this
    if(!employeeId){
      employeeId = this.props.user._id;
    }

    this.setState({
      employeeId,
    });
  }


  showNoSurveyDataModal(){
    this.setState({
      modalMessage: 'This page requires user survey data, which is coming soon to the new app.'
    });
  }

  showComingSoonModal(){
    this.setState({
      modalMessage: 'This feature is coming soon to the new app.'
    });
  }

  hideModal(){
    this.setState({
      modalMessage: null
    });
  }

  renderMessageModal(){
    const message = this.state.modalMessage;

    return <MessageModal message={this.state.modalMessage} hide={this.hideModal.bind(this)} visible={this.state.modalMessage} />
  }

  render(){

    // console.log('rendering manager sidebar nav...');
    // console.log('sidebarnav loaded with route params: ', this.props.route);

    if(!this.props.viewingUser.data){
      return null;
    }

    const { route, deals } = this.props;

    const { firstName, lastName } = this.props.viewingUser.data;
    const organizationId = this.props.user.organizationId;

    const employeeId = this.state.employeeId;
    const navLinkPrefix = '/people/' + employeeId;

    const showImperativesMenu = route.indexOf('imperatives') !== -1;
    const { hoveringNonImperativesPage } = this.state;

    const enableDevelopmentPages = !isProduction();

    const activeDeals = _.filter(deals, deal => {
      return deal.status === 'open';
    });

    return (
      <div className={`page-sidebar ${hoveringNonImperativesPage ? 'hovering-non-imperative-page ' : ''} ${showImperativesMenu ? 'showing-imperatives ' : ''}`}>

        {this.renderMessageModal()}

        <div className="sidebar-header">
          <h2>{firstName + ' ' + lastName}</h2>
        </div>
        <ul className="deals">
          <div className="page-name">Seven Imperatives</div>
          <ul className="deals-list">
            <NavLink exact to={`${navLinkPrefix}/imperatives`}>
              <li>Deal Summary</li>
            </NavLink>
            {enableDevelopmentPages &&
              <NavLink exact to={`${navLinkPrefix}/imperatives-funnel`}>
                <li>Funnel View</li>
              </NavLink>
            }
            <li className="divider"></li>
            {_.map(activeDeals, deal => {
              const { _id, name } = deal;
              return(
                <NavLink
                  key={_id}
                  to={`${navLinkPrefix}/imperatives/${_id}`}
                >
                  <li>{name}</li>
                </NavLink>
              )
            })}
          </ul>
        </ul>

        <ul
          className="pages"
          onMouseEnter={() => { this.setState({hoveringNonImperativesPage: true}); }}
          onMouseLeave={() => { this.setState({hoveringNonImperativesPage: false}); }}
        >
          <li
            className="imperatives"
            onMouseEnter={() => { this.setState({hoveringNonImperativesPage: false}); }}
            onMouseLeave={() => { this.setState({hoveringNonImperativesPage: true}); }}
            >
            <NavLink to={`${navLinkPrefix}/imperatives`}>
              <div className="page-icon">{getIcon('imperatives')}</div>
              <div className="page-name">Seven Imperatives</div>
            </NavLink>
          </li>
          <li className="section-divider"></li>
          <li>
            <NavLink to={`${navLinkPrefix}/sprint`}>
              <div className="page-icon">{getIcon('sprint')}</div>
              <div className="page-name">Velocity Sprint</div>
            </NavLink>
          </li>
          <li>
            <NavLink to={`${navLinkPrefix}/plan`}>
              <div className="page-icon">{getIcon('plan')}</div>
              <div className="page-name">Action Plan</div>
            </NavLink>
          </li>
          <li>
            <NavLink to={`${navLinkPrefix}/talents`}>
              <div className="page-icon">{getIcon('talents')}</div>
              <div className="page-name">Talent Card</div>
            </NavLink>
          </li>
          <li className="section-divider"></li>
            <li className="disabled">
              <NavLink to={`${navLinkPrefix}/match`} onClick={(e) => { e.preventDefault(); this.showNoSurveyDataModal(); }}>
                <div className="page-icon">{getIcon('match')}</div>
                <div className="page-name">Talent & Culture Match</div>
                <div className="disabled-info">{getIcon('info-bold')}</div>
              </NavLink>
            </li>
            <li className="disabled">
              <NavLink to={`${navLinkPrefix}/predictive`} onClick={(e) => { e.preventDefault(); this.showNoSurveyDataModal(); }}>
                <div className="page-icon">{getIcon('predictive')}</div>
                <div className="page-name">Predictive Summary</div>
                <div className="disabled-info">{getIcon('info-bold')}</div>
              </NavLink>
            </li>
            <li className="disabled">
              <NavLink to={`${navLinkPrefix}/interview`} onClick={(e) => { e.preventDefault(); this.showComingSoonModal(); }}>
                <div className="page-icon">{getIcon('interview')}</div>
                <div className="page-name">Interview Questions</div>
                <div className="disabled-info">{getIcon('info-bold')}</div>
              </NavLink>
            </li>
            <li className="disabled">
              <NavLink to={`${navLinkPrefix}/winner`} onClick={(e) => { e.preventDefault(); this.showNoSurveyDataModal(); }}>
                <div className="page-icon">{getIcon('winner')}</div>
                <div className="page-name">Winner's Card</div>
                <div className="disabled-info">{getIcon('info-bold')}</div>
              </NavLink>
            </li>
            <li className="section-divider"></li>
          <li className="disabled">
            <NavLink to={`${navLinkPrefix}/responses`} onClick={(e) => { e.preventDefault(); this.showNoSurveyDataModal(); }}>
              <div className="page-icon">{getIcon('responses')}</div>
              <div className="page-name">Review Responses</div>
              <div className="disabled-info">{getIcon('info-bold')}</div>
            </NavLink>
          </li>
          <li>
            <NavLink to={`${navLinkPrefix}/profile`}>
              <div className="page-icon">{getIcon('profile')}</div>
              <div className="page-name">View / Edit Profile</div>
            </NavLink>
          </li>
        </ul>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps){
  return {
    user: state.user,
    deals: state.deals.data,
    viewingUser: state.viewingUser,
    route: ownProps.location.pathname,
  }
}

export default withRouter(connect(mapStateToProps, {})(ManagerSidebarNav));



// WEBPACK FOOTER //
// ./src/components/shared/managerSidebarNav.js